import { render } from "./TheFileViewer.vue?vue&type=template&id=ab25c482&scoped=true&ts=true"
import script from "./TheFileViewer.vue?vue&type=script&lang=ts"
export * from "./TheFileViewer.vue?vue&type=script&lang=ts"

import "./TheFileViewer.vue?vue&type=style&index=0&id=ab25c482&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab25c482"]])

export default __exports__